<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M3.755 8.91521C3.10795 8.18557 3.00039 7.12374 3.48797 6.27917L3.52163 6.22083C4.00923 5.37628 4.98255 4.93848 5.93796 5.13397H5.93805C6.3297 5.21412 6.73713 5.148 7.08333 4.94812C7.42953 4.74824 7.6905 4.42845 7.81692 4.04922C8.12531 3.12404 8.99113 2.5 9.96635 2.5H10.0337C11.0089 2.5 11.8747 3.12404 12.1831 4.04922C12.3095 4.42845 12.5705 4.74823 12.9167 4.94811C13.2629 5.148 13.6703 5.21412 14.062 5.13398H14.0621C15.0174 4.93851 15.9907 5.3763 16.4783 6.22083L16.512 6.27917C16.9996 7.12375 16.8921 8.18559 16.245 8.91525C15.9798 9.21435 15.8333 9.60025 15.8333 10C15.8333 10.3998 15.9798 10.7857 16.245 11.0848C16.8921 11.8145 16.9996 12.8763 16.512 13.7209L16.4784 13.7792C15.9908 14.6238 15.0175 15.0615 14.0621 14.8661L14.0618 14.866C13.6702 14.7859 13.2628 14.852 12.9167 15.0518C12.5705 15.2517 12.3095 15.5715 12.1831 15.9507C11.8747 16.8759 11.0088 17.5 10.0336 17.5H9.96644C8.99117 17.5 8.12532 16.8759 7.81691 15.9507C7.6905 15.5715 7.42953 15.2517 7.08333 15.0518C6.73718 14.852 6.3298 14.7859 5.93821 14.866L5.93796 14.866C4.98256 15.0615 4.00926 14.6237 3.52167 13.7792L3.488 13.7208C3.00039 12.8763 3.10793 11.8144 3.75498 11.0847C4.02021 10.7857 4.16666 10.3998 4.16667 10C4.16668 9.60024 4.02023 9.21432 3.755 8.91521Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <circle
      cx="10"
      cy="10"
      r="2.5"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
